module.exports = __webpack_public_path__ + "static/img/11.b9892c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/11.png
// module id = lOME
// module chunks = 0